import React, { FunctionComponent } from "react";

import { Post } from "para-lib";
import { message } from "para-ui";

import Button from "@material-ui/core/Button";

interface RequestProps {
  url: string;
  ctx: string;
}

export interface ParaStepsProps {
  sendRequest: RequestProps; // 发送验证码的接口
  param: any; // 请求传参
  account?: any;
  callback?: Function; // 触发点击的回调
  isText?: boolean;
}

let intervalTimer: any = null; // 定时器

const Countdown: FunctionComponent<ParaStepsProps> = (props) => {
  // const {formatMessage: intl} = useIntl();   // 国际化方法
  const { sendRequest, param, callback, isText = false } = props;
  const [intervalBoolean, setIntervalBoolean] = React.useState<boolean>(false); // 用于控制倒计时按钮的状态
  const [intervalText, setIntervalText] = React.useState<any>("获取验证码"); // 用于控制倒计时的按钮的文字 获取验证码
  const [verifyCodeEffectTime, setVerifyCodeEffectTime] =
    React.useState<number>(60);

  /* 获取验证码 */
  const getValidateCode = async () => {
    callback && callback();
    // 清除定时器
    if (intervalTimer) clearInterval(intervalTimer);
    setIntervalBoolean(true); // 设置成不可点击
    /* 接口获取验证码 */

    const { data, err } = await Post(
      {
        url: sendRequest.url,
        ctx: sendRequest.ctx,
      },
      param
    );
    // 发送失败就不开起倒计时
    if (err) {
      setIntervalBoolean(false);
      return;
    }
    // 发送成功在开启倒计时
    if (data.code === 0 || data.code === "0") {
      // 发送成功在开启倒计时
      setIntervalText(verifyCodeEffectTime);
      intervalTimer = setInterval(() => {
        setIntervalText((prevState: any) => {
          prevState--;
          if (prevState <= 0) {
            setIntervalText("获取验证码"); // 获取验证码
            setIntervalBoolean(false);
            clearInterval(intervalTimer);
          }
          return prevState;
        });
      }, 1000);
    } else {
      setIntervalBoolean(false);
      message.warning(data.msg || data.data);
    }
  };

  return (
    <Button
      size={"small"}
      className={"form-code-button"}
      disabled={intervalBoolean}
      variant={isText ? "text" : "outlined"}
      color={"primary"}
      onClick={getValidateCode}
      disableElevation
    >
      {/*获取验证码 秒后重发*/}
      {intervalBoolean && intervalText !== "获取验证码"
        ? `${intervalText}秒后重发`
        : intervalText}
    </Button>
  );
};

export default Countdown;
